import Model from './model';

export default class Card extends Model {
  static fields = [
    { name: 'brand', defaultValue: '' },
    { name: 'last4', defaultValue: '' },
  ];
}